import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { GenericHttpService, ParametrosService, ConfiguracoesProjeto } from '../../../shared/index';
import { SituacaoConsumidorReferenciaSorteioModel } from './situacao-consumidor-referencia-sorteio.model';
import { FiltroBuscaSituacaoConsumidorReferenciaSorteio } from '../../../shared/filter/filtro-busca-situacao-consumidor-referencia-sorteio';

@Injectable()
export class SituacaoConsumidorReferenciaSorteioService {

  public _urlBase: string;

  public model: SituacaoConsumidorReferenciaSorteioModel = new SituacaoConsumidorReferenciaSorteioModel();

  public change = new Subject<SituacaoConsumidorReferenciaSorteioModel>();

  public error = new Subject<string>();

  public configuracao: ConfiguracoesProjeto;

  public mensagemErro: string;

  public url: string;

  constructor(private readonly genericHttpService: GenericHttpService<SituacaoConsumidorReferenciaSorteioModel>,
              private readonly parametrosService: ParametrosService,
              ) { }

  get urlBase() {
      this.configuracao = this.parametrosService.getConfiguracao();
      this._urlBase = this.configuracao.uri + 'situacao-consumidor-sorteio/';
      return this._urlBase;
  }

  getSituacaoConsumidorReferenciaSorteio(filtro: FiltroBuscaSituacaoConsumidorReferenciaSorteio): Observable<SituacaoConsumidorReferenciaSorteioModel> {

    let searchParams: URLSearchParams = new URLSearchParams();
      searchParams.append('consumidorId', filtro.consumidorId.toString());
      searchParams.append('sorteioId', filtro.sorteioId.toString());

      return this.genericHttpService.getAny(this.urlBase + `situacao-consumidor-referencia-sorteio/`, searchParams);
  }

}




// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/situacao-consumidor-referencia-sorteio.service.ts